<template lang="">
  <modal-padrao
    ref="modal-associar-pontos"
    max-width="50%"
    :titulo="$t('modulos.modelo_instrumento.botoes.selecionar_pontos')"
    :titulo-ok="$t('geral.botoes.confirmar')"
    :titulo-cancelar="$t('geral.botoes.cancelar')"
    :ok-desabilitado="!tabela.selecionados[0]"
    @ok="associarPontos()"
  >
    <tabela-padrao-prime-vue
      ref="tabela"
      v-model="tabela.selecionados"
      :dados="tabela.dados"
      class="mt-2"
      :colunas="tabela.colunas"
      :quantidade-itens="tabela.quantidadeItens"
      :quantidade-paginas="tabela.quantidadePaginas"
      paginacao-em-memoria
      sem-paginacao
      filtro-geral
      ajustar-altura-linha
      :pagina-atual="tabela.paginaAtual"
      :mostrar-acoes="false"
      :filters="filters"
      :global-filters="tabela.colunas.map(c => c.value)"
    />
  </modal-padrao>
</template>

<script>
import TipoInstrumentoService from '@/common/services/cadastros/TipoInstrumentoService.js';
import { FilterMatchMode } from 'primevue/api';
import helpers from '@common/utils/helpers.js';

export default {
  data() {
    return {
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      flagPontosDuplicados: null,
      tabela: {
        selecionados: [],
        dados: [],
        colunas: [
          {
            value: 'acoes',
            text: '',
          },
          {
            value: 'valor',
            text: this.$t('modulos.modelo_instrumento.tabela.pontos.valor'),
            sortable: true,
          },
          {
            value: 'descricao',
            text: this.$t('modulos.modelo_instrumento.tabela.pontos.descricao'),
            sortable: true,
          },
          {
            value: 'tipoPonto',
            text: this.$t('modulos.modelo_instrumento.tabela.pontos.tipoPonto'),
            sortable: true,
            formatter: v => helpers.TipoPontoEnum.find(el => el.value == v)?.text
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        porPagina: 10,
      },
      filtroAplicado: {
        nome: ""
      },
      referenciaFaixa: null
    };
  },
  methods: {
    abrirModal: function (tipoInstrumentoId, faixaSelecionada) {
      this.buscarTipoInstrumento(tipoInstrumentoId)
      this.referenciaFaixa = faixaSelecionada
      this.$refs['modal-associar-pontos'].abrirModal();
    },
    buscarTipoInstrumento(id) {
      TipoInstrumentoService.buscar(id)
        .then((res) => {
          this.tabela.selecionados = [];
          this.tabela.dados = res.data.faixa
            .find(el => el.descricao == this.referenciaFaixa.descricao && el.resolucao == this.referenciaFaixa.resolucao)
            ?.tipoInstrumentoFaixaPonto;
            this.flagPontosDuplicados = res.data.flagPontosDuplicados;
            this.tabela.quantidadeItens = this.tabela.dados?.length
            this.tabela.quantidadePaginas = Math.ceil(this.tabela.quantidadeItens / this.tabela.porPagina) || 0
        })
    },
    associarPontos(){
      this.tabela.selecionados.forEach(ponto => {
        if (this.flagPontosDuplicados == false) {
          const pontoExistente = this.referenciaFaixa.modeloInstrumentoFaixaPonto
            .find(el => el.valor == ponto.valor && el.tipoPonto == ponto.tipoPonto)
          if (pontoExistente) return;
        }
        this.referenciaFaixa.modeloInstrumentoFaixaPonto.push(ponto)
      })
      this.$refs['modal-associar-pontos'].fecharModal()
    }
  },
}
</script>
